"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils";
import React, { useEffect, useState, useRef } from "react";
interface ShootingStar {
  id: number;
  x: number;
  y: number;
  angle: number;
  scale: number;
  speed: number;
  distance: number;
}
interface ShootingStarsProps {
  minSpeed?: number;
  maxSpeed?: number;
  minDelay?: number;
  maxDelay?: number;
  starColor?: string;
  trailColor?: string;
  starWidth?: number;
  starHeight?: number;
  className?: string;
}
const getRandomStartPoint = () => {
  const side = Math.floor(Math.random() * 4);
  const offset = Math.random() * window.innerWidth;
  switch (side) {
    case 0:
      return {
        x: offset,
        y: 0,
        angle: 45
      };
    case 1:
      return {
        x: window.innerWidth,
        y: offset,
        angle: 135
      };
    case 2:
      return {
        x: offset,
        y: window.innerHeight,
        angle: 225
      };
    case 3:
      return {
        x: 0,
        y: offset,
        angle: 315
      };
    default:
      return {
        x: 0,
        y: 0,
        angle: 45
      };
  }
};
export const ShootingStars: React.FC<ShootingStarsProps> = t0 => {
  const $ = _c(26);
  const {
    minSpeed: t1,
    maxSpeed: t2,
    minDelay: t3,
    maxDelay: t4,
    starColor: t5,
    trailColor: t6,
    starWidth: t7,
    starHeight: t8,
    className
  } = t0;
  const minSpeed = t1 === undefined ? 10 : t1;
  const maxSpeed = t2 === undefined ? 30 : t2;
  const minDelay = t3 === undefined ? 1200 : t3;
  const maxDelay = t4 === undefined ? 4200 : t4;
  const starColor = t5 === undefined ? "#9E00FF" : t5;
  const trailColor = t6 === undefined ? "#2EB9DF" : t6;
  const starWidth = t7 === undefined ? 10 : t7;
  const starHeight = t8 === undefined ? 1 : t8;
  const [star, setStar] = useState(null);
  const svgRef = useRef(null);
  let t10;
  let t9;
  if ($[0] !== maxDelay || $[1] !== maxSpeed || $[2] !== minDelay || $[3] !== minSpeed) {
    t9 = () => {
      const createStar = () => {
        const {
          x,
          y,
          angle
        } = getRandomStartPoint();
        const newStar = {
          id: Date.now(),
          x,
          y,
          angle,
          scale: 1,
          speed: Math.random() * (maxSpeed - minSpeed) + minSpeed,
          distance: 0
        };
        setStar(newStar);
        const randomDelay = Math.random() * (maxDelay - minDelay) + minDelay;
        setTimeout(createStar, randomDelay);
      };
      createStar();
      return _temp;
    };
    t10 = [minSpeed, maxSpeed, minDelay, maxDelay];
    $[0] = maxDelay;
    $[1] = maxSpeed;
    $[2] = minDelay;
    $[3] = minSpeed;
    $[4] = t10;
    $[5] = t9;
  } else {
    t10 = $[4];
    t9 = $[5];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[6] !== star) {
    t11 = () => {
      const moveStar = () => {
        if (star) {
          setStar(_temp2);
        }
      };
      const animationFrame = requestAnimationFrame(moveStar);
      return () => cancelAnimationFrame(animationFrame);
    };
    t12 = [star];
    $[6] = star;
    $[7] = t11;
    $[8] = t12;
  } else {
    t11 = $[7];
    t12 = $[8];
  }
  useEffect(t11, t12);
  let t13;
  if ($[9] !== className) {
    t13 = cn("pointer-events-none absolute inset-0 h-full w-full", className);
    $[9] = className;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== star || $[12] !== starHeight || $[13] !== starWidth) {
    t14 = star && <rect key={star.id} x={star.x} y={star.y} width={starWidth * star.scale} height={starHeight} fill="url(#gradient)" transform={`rotate(${star.angle}, ${star.x + starWidth * star.scale / 2}, ${star.y + starHeight / 2})`} />;
    $[11] = star;
    $[12] = starHeight;
    $[13] = starWidth;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== trailColor) {
    t15 = <stop offset="0%" style={{
      stopColor: trailColor,
      stopOpacity: 0
    }} />;
    $[15] = trailColor;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== starColor) {
    t16 = <stop offset="100%" style={{
      stopColor: starColor,
      stopOpacity: 1
    }} />;
    $[17] = starColor;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t15 || $[20] !== t16) {
    t17 = <defs><linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">{t15}{t16}</linearGradient></defs>;
    $[19] = t15;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t13 || $[23] !== t14 || $[24] !== t17) {
    t18 = <svg ref={svgRef} className={t13}>{t14}{t17}</svg>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  return t18;
};
function _temp() {}
function _temp2(prevStar) {
  if (!prevStar) {
    return null;
  }
  const newX = prevStar.x + prevStar.speed * Math.cos(prevStar.angle * Math.PI / 180);
  const newY = prevStar.y + prevStar.speed * Math.sin(prevStar.angle * Math.PI / 180);
  const newDistance = prevStar.distance + prevStar.speed;
  const newScale = 1 + newDistance / 100;
  if (newX < -20 || newX > window.innerWidth + 20 || newY < -20 || newY > window.innerHeight + 20) {
    return null;
  }
  return {
    ...prevStar,
    x: newX,
    y: newY,
    distance: newDistance,
    scale: newScale
  };
}